// Constantes de Features (Módulos) - Mapeamento com backend
export const FEATURE = {
  USER: 'USER',
  ROLE: 'ROLE',
  COMPANY: 'COMPANY',
  REPORTS: 'REPORTS',
  DASHBOARD: 'DASHBOARD',
  CONFIGURATION: 'CONFIGURATION',
  INTEGRATIONS: 'INTEGRATIONS',
  TENANT: 'TENANT',
  PROJECT: 'PROJECT',
  PORTFOLIO: 'PORTFOLIO',
};

// Constantes de Actions (Ações) - Mapeamento com backend
export const ACTION = {
  VIEW: 'VIEW',
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  READ: 'READ',
  DELETE: 'DELETE',
  MANAGE: 'MANAGE',
  EXPORT: 'EXPORT',
  PRINT: 'PRINT',
  SHARE: 'SHARE',
  EXECUTE: 'EXECUTE',
  CONFIGURE: 'CONFIGURE',
};

// Mapeamento do enum numérico do backend (Feature) para strings
export const FEATURE_CODE_TO_KEY = {
  0: 'USER',
  1: 'ROLE', 
  2: 'COMPANY',
  3: 'REPORTS',
  4: 'DASHBOARD',
  5: 'CONFIGURATION',
  6: 'INTEGRATIONS',
  7: 'TENANT',
  8: 'PROJECT',
  9: 'PORTFOLIO',
};

// Reverse map para usar no envio ao backend
export const FEATURE_KEY_TO_CODE = Object.keys(FEATURE_CODE_TO_KEY).reduce((acc, code) => {
  const key = FEATURE_CODE_TO_KEY[code];
  acc[key] = Number(code);
  return acc;
}, {});

// Mapeamento do enum numérico do backend (FeatureAction) para strings
export const ACTION_CODE_TO_KEY = {
  0: 'VIEW',
  1: 'CREATE',
  2: 'EDIT',
  3: 'READ',
  4: 'DELETE',
  5: 'MANAGE',
  6: 'EXPORT',
  7: 'PRINT',
  8: 'SHARE',
  9: 'EXECUTE',
  10: 'CONFIGURE'
};

// Reverse map para ações
export const ACTION_KEY_TO_CODE = Object.keys(ACTION_CODE_TO_KEY).reduce((acc, code) => {
  const key = ACTION_CODE_TO_KEY[code];
  acc[key] = Number(code);
  return acc;
}, {});

// Mapeamento do enum numérico do backend (GranularResourceType) para strings
export const RESOURCE_TYPE_CODE_TO_KEY = {
  0: 'reports',
  1: 'integrations',
  2: 'projects', // Mudado para plural para consistência
};

export const RESOURCE_KEY_TO_TYPE_CODE = {
  reports: 0,
  integrations: 1,
  projects: 2,
};

// Lista de todas as permissões disponíveis (para compatibilidade)
export const PERMISSIONS = {
  // Usuários
  VIEW_USER: 'VIEW_USER',
  CREATE_USER: 'CREATE_USER',
  EDIT_USER: 'EDIT_USER',
  DELETE_USER: 'DELETE_USER',
  MANAGE_USER: 'MANAGE_USER',

  // Tenant
  VIEW_TENANT: 'VIEW_TENANT',
  EDIT_TENANT: 'EDIT_TENANT',
  MANAGE_TENANT: 'MANAGE_TENANT',

  // Roles/Permissões
  VIEW_ROLE: 'VIEW_ROLE',
  CREATE_ROLE: 'CREATE_ROLE',
  EDIT_ROLE: 'EDIT_ROLE',
  DELETE_ROLE: 'DELETE_ROLE',
  MANAGE_ROLE: 'MANAGE_ROLE',
  
  // Empresa
  VIEW_COMPANY: 'VIEW_COMPANY',
  EDIT_COMPANY: 'EDIT_COMPANY',
  MANAGE_COMPANY: 'MANAGE_COMPANY',
  
  // Relatórios
  VIEW_REPORTS: 'VIEW_REPORTS',
  CREATE_REPORTS: 'CREATE_REPORTS',
  EDIT_REPORTS: 'EDIT_REPORTS',
  DELETE_REPORTS: 'DELETE_REPORTS',
  EXPORT_REPORTS: 'EXPORT_REPORTS',
  MANAGE_REPORTS: 'MANAGE_REPORTS',

  // Projetos
  VIEW_PROJECT: 'VIEW_PROJECT',
  CREATE_PROJECT: 'CREATE_PROJECT',
  EDIT_PROJECT: 'EDIT_PROJECT',
  DELETE_PROJECT: 'DELETE_PROJECT',
  MANAGE_PROJECT: 'MANAGE_PROJECT',
  
  // Dashboard
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',
  MANAGE_DASHBOARD: 'MANAGE_DASHBOARD',
  
  // Configurações
  VIEW_CONFIGURATION: 'VIEW_CONFIGURATION',
  MANAGE_CONFIGURATION: 'MANAGE_CONFIGURATION',

  // Integrações
  VIEW_INTEGRATIONS: 'VIEW_INTEGRATIONS',
  CREATE_INTEGRATIONS: 'CREATE_INTEGRATIONS',
  EDIT_INTEGRATIONS: 'EDIT_INTEGRATIONS',
  DELETE_INTEGRATIONS: 'DELETE_INTEGRATIONS',
  MANAGE_INTEGRATIONS: 'MANAGE_INTEGRATIONS',
  EXECUTE_INTEGRATIONS: 'EXECUTE_INTEGRATIONS',

  RUN_INCREMENTAL: 'RUN_INCREMENTAL',
};

// Features organizadas para exibição
export const FEATURES_LIST = [
  
  { 
    id: FEATURE.USER, 
    name: 'Usuários', 
    actions: [
      { id: PERMISSIONS.VIEW_USER, name: 'Visualizar' },
      { id: PERMISSIONS.CREATE_USER, name: 'Criar' },
      { id: PERMISSIONS.EDIT_USER, name: 'Editar' },
      { id: PERMISSIONS.DELETE_USER, name: 'Excluir' },
    
    ]
  },
 
  { 
    id: FEATURE.COMPANY, 
    name: 'Empresa', 
    actions: [
      { id: PERMISSIONS.VIEW_COMPANY, name: 'Visualizar' },
      { id: PERMISSIONS.EDIT_COMPANY, name: 'Editar' },
    ]
  },
  { 
    id: FEATURE.REPORTS, 
    name: 'Relatórios', 
    actions: [
      { id: PERMISSIONS.VIEW_REPORTS, name: 'Visualizar' },
      { id: PERMISSIONS.CREATE_REPORTS, name: 'Criar' },
      { id: PERMISSIONS.EDIT_REPORTS, name: 'Editar' },
      { id: PERMISSIONS.DELETE_REPORTS, name: 'Excluir' },
      { id: PERMISSIONS.EXPORT_REPORTS, name: 'Exportar' },
    ]
  },
  { 
    id: FEATURE.INTEGRATIONS, 
    name: 'Integrações', 
    actions: [
      { id: PERMISSIONS.VIEW_INTEGRATIONS, name: 'Visualizar' },
      { id: PERMISSIONS.CREATE_INTEGRATIONS, name: 'Criar' },
      { id: PERMISSIONS.EDIT_INTEGRATIONS, name: 'Editar' },
      { id: PERMISSIONS.DELETE_INTEGRATIONS, name: 'Excluir' },
      { id: PERMISSIONS.RUN_INCREMENTAL, name: 'Rodar incremental' },
      
    ]
  },
  
  { 
    id: FEATURE.PROJECT, 
    name: 'Projetos', 
    actions: [
      { id: PERMISSIONS.VIEW_PROJECT, name: 'Visualizar' },
      { id: PERMISSIONS.CREATE_PROJECT, name: 'Criar' },
      { id: PERMISSIONS.EDIT_PROJECT, name: 'Editar' },
      { id: PERMISSIONS.DELETE_PROJECT, name: 'Excluir' },
    ]
  },
  
];

// Função para verificar se é super admin
export const isSuperAdmin = (user) => {
  if (!user) return false;
  
  // Verifica múltiplas possibilidades para identificar admin
  return user.roles.some(role => role.name === 'RoleAdmin')
};

// ===========================
// SISTEMA DE PERMISSÕES GRANULARES
// ===========================

// Função para verificar se o usuário tem acesso a um recurso específico
export const canAccessResource = (userPermissions, resourceType, resourceId) => {
  if (!userPermissions) return false;

  // Formato do backend (array de objetos)
  if (Array.isArray(userPermissions)) {
    const expectedTypeCode = RESOURCE_KEY_TO_TYPE_CODE[resourceType];
    if (expectedTypeCode === undefined) return false;

    const hasAnyOfType = userPermissions.some(
      (perm) => perm.resourceType === expectedTypeCode,
    );
    if (!hasAnyOfType) return true;

    return userPermissions.some(
      (perm) =>
        perm.resourceType === expectedTypeCode &&
        String(perm.resourceId) === String(resourceId),
    );
  }

  // Formato legado (objeto com arrays) - manter compatibilidade
  if (!userPermissions[resourceType]) return true;

  return (
    Array.isArray(userPermissions[resourceType]) &&
    userPermissions[resourceType].map(String).includes(String(resourceId))
  );
};

// Função para obter todos os IDs de recursos que o usuário pode acessar
export const getUserAccessibleResources = (user, resourceType) => {
  if (isSuperAdmin(user)) {
    return null; // Admin tem acesso total
  }

  const granularPermissions = user?.granularPermissions;
  if (!granularPermissions) return null;

  // Formato do backend (array de objetos)
  if (Array.isArray(granularPermissions)) {
    const expectedTypeCode = RESOURCE_KEY_TO_TYPE_CODE[resourceType];
    if (expectedTypeCode === undefined) return null;

    const hasAnyOfType = granularPermissions.some(
      (perm) => perm.resourceType === expectedTypeCode,
    );
    if (!hasAnyOfType) return null;

    return granularPermissions
      .filter((perm) => perm.resourceType === expectedTypeCode)
      .map((perm) => perm.resourceId);
  }

  // Formato legado
  if (!granularPermissions[resourceType]) return null;

  return granularPermissions[resourceType] || [];
};

// Função para verificar se pode acessar relatório específico
export const canAccessReport = (user, reportId) => {
  if (isSuperAdmin(user)) return true;
  return canAccessResource(user?.granularPermissions, 'reports', reportId);
};

// Função para verificar se pode acessar integração específica
export const canAccessIntegration = (user, integrationId) => {
  if (isSuperAdmin(user)) return true;
  return canAccessResource(user?.granularPermissions, 'integrations', integrationId);
};

// Função para verificar se pode acessar dashboard específico
export const canAccessDashboard = (user, dashboardId) => {
  if (isSuperAdmin(user)) return true;
  return canAccessResource(user?.granularPermissions, 'dashboards', dashboardId);
};

// Função para verificar se pode acessar projeto específico
export const canAccessProject = (user, projectId) => {
  if (isSuperAdmin(user)) return true;
  return canAccessResource(user?.granularPermissions, 'projects', projectId);
};

// Função para verificar se usuário tem algum acesso a um tipo de recurso
export const hasAnyAccessToResourceType = (user, resourceType) => {
  if (isSuperAdmin(user)) return true;
  
  const accessibleIds = getUserAccessibleResources(user, resourceType);
  return (
    accessibleIds === null ||
    (Array.isArray(accessibleIds) && accessibleIds.length > 0)
  );
};

// Função para filtrar uma lista de recursos baseada nas permissões do usuário
export const filterResourcesByPermission = (user, resourceType, resources, getIdFunction = (item) => item.id) => {
  if (isSuperAdmin(user)) {
    return resources; // Admin vê tudo
  }

  const accessibleIds = getUserAccessibleResources(user, resourceType);
  if (!accessibleIds) {
    return resources; // null indica acesso total
  }

  return resources.filter(resource => {
    const resourceId = typeof getIdFunction === 'function' ? getIdFunction(resource) : resource[getIdFunction];
    return accessibleIds.map(String).includes(String(resourceId));
  });
};

// Função helper para debug
export const debugUserPermissions = (user) => {
  console.log('=== DEBUG USER PERMISSIONS ===');
  console.log('Usuário:', user?.userName || user?.username);
  console.log('É Super Admin:', isSuperAdmin(user));
  console.log('Permissions:', user?.permissions);
  console.log('Permissões Granulares:', user?.granularPermissions);
  console.log('===============================');
};

// Função para filtrar rotas baseado nas permissões do usuário
export const filterRoutesByPermissions = (routes, user, canFunction, hasAnyReports, hasAnyIntegrations, hasAnyDashboards) => {
  if (!user) return [];

  return routes.filter(route => {
    // Rotas sempre visíveis ou sem permissões específicas
    if (!route.feature && !route.requiresResourceAccess) {
      return true;
    }

    // Verificar permissão básica da feature
    if (route.feature) {
      const hasBasicPermission = canFunction(route.feature, route.actions || []);
      if (!hasBasicPermission) {
        return false;
      }
    }

    // Verificar acesso a recursos granulares
    if (route.requiresResourceAccess) {
      switch (route.requiresResourceAccess) {
        case 'reports':
          return hasAnyReports();
        case 'integrations':
          return hasAnyIntegrations();
        case 'dashboards':
          return hasAnyDashboards();
        case 'projects':
          return hasAnyAccessToResourceType(user, 'projects');
        default:
          return true;
      }
    }

    return true;
  });
};

// Função para filtrar rotas baseado nas roles do usuário (sistema antigo compatível)
export const filterRoutesByRoles = (routes, user) => {
  if (!user) return [];

  // Se é super admin, vê todas as rotas
  if (isSuperAdmin(user)) {
    return routes;
  }

  const userRoleNames = Array.isArray(user.roles)
    ? user.roles.map((role) => role.name)
    : [];

  const hasRoleAccess = (route) => {
    if (!route.roles || route.roles.length === 0) return true;
    return route.roles.some((requiredRole) => userRoleNames.includes(requiredRole));
  };

  const filterRecursive = (items) =>
    (items || []).reduce((acc, route) => {
      const filteredChildren = route.children
        ? filterRecursive(route.children)
        : undefined;
      const routeVisible = hasRoleAccess(route);
      const hasVisibleChildren = Array.isArray(filteredChildren) && filteredChildren.length > 0;

      if (!routeVisible && !hasVisibleChildren) return acc;

      acc.push({
        ...route,
        ...(route.children ? { children: filteredChildren || [] } : {}),
      });
      return acc;
    }, []);

  return filterRecursive(routes);
}; 
